<template>
  <div :class="$style.container">
    <div :class="$style.stepNumber">
      <CircularStepNumber
        backgroundColor="white"
        color="black"
        :stepNumber="stepNumber"
      />
    </div>
    <div :class="$style.content">
      <h4
        v-if="stepTitle"
        :class="$style.stepTitle"
      >
        {{ stepTitle }}
      </h4>
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import CircularStepNumber from 'client/components/CircularStepNumber.vue';

export default {
  name: 'StepWizard',

  components: {
    CircularStepNumber,
  },

  props: {
    stepNumber: {
      required: true,
      type: [Number, String],
    },
    stepTitle: {
      default: '',
      type: String,
    },
  },
};
</script>

<style module>
.container {
  align-items: stretch;
  display: flex;
  flex-direction: row;
}

.content {
  margin: 0 50px 0 20px;
  width: 100%;
}

.container .stepTitle {
  font-size: 14px;
  font-weight: 700;
  margin: 5px 0 10px 0;
}

.container .stepNumber {
  flex-basis: 35px;
}
</style>
